import { createSlice } from "@reduxjs/toolkit";

const initialDeleteItemState = { isOpen: false, item_id: null }

const deleteItemSlice = createSlice({
    name: 'delete_item',
    initialState: initialDeleteItemState,
    reducers: {
        openModal(state, action) {
            state.isOpen = true
            state.item_id = action.payload
        },
        closeModal(state) {
            state.isOpen = false
            state.item_id = null
        },
    }
})

export const deleteItemActions = deleteItemSlice.actions;
export default deleteItemSlice